export var EControllerState;
(function (EControllerState) {
    EControllerState["HEALTHY"] = "Healthy";
    EControllerState["WARNING"] = "Warning";
    EControllerState["UNCONFIGURED"] = "Unconfigured";
    EControllerState["OFFLINE"] = "Offline";
    EControllerState["UPDATING"] = "Updating";
})(EControllerState || (EControllerState = {}));
